import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class GetReportingPeriodPermissionsInteractor {
  private applicantService: IApplicantService;

  constructor(applicantService) {
    this.applicantService = applicantService;
  }

  async execute(applicantId: number, applicantReportingPeriodId: number) {
    return this.applicantService.getApplicantReportingPeriodPermissions(
      applicantId,
      applicantReportingPeriodId
    );
  }
}
